import { useState } from 'react';
import toast from 'react-hot-toast';
import SelectorDeTema from '../../components/SelectorDeTema';
import { useTemaStore } from '../../store/temaStore';
import useAuthStore from '../../store/authStore';

/**
 * Configuración → Apariencia: el tema de la consola para toda la cuenta (todas sus
 * empresas y usuarios). Solo el administrador lo cambia; el resto lo ve.
 */
export default function Apariencia() {
  const { tema, cambiar } = useTemaStore();
  const esAdmin = useAuthStore((s) => s.user?.role === 'admin');
  const [guardando, setGuardando] = useState(null);

  const elegir = async (id) => {
    if (!esAdmin) { toast.error('Solo un administrador de la cuenta puede cambiar la apariencia'); return; }
    setGuardando(id);
    try {
      await cambiar(id);
      toast.success('Apariencia actualizada para toda la cuenta');
    } catch (e) {
      toast.error(e.response?.data?.error || 'No se pudo cambiar la apariencia');
    } finally {
      setGuardando(null);
    }
  };

  return (
    <div className="space-y-6 w-full">
      <div>
        <h2 className="text-lg font-semibold text-gray-900">Tema de la consola</h2>
        <p className="text-sm text-gray-500 mt-1">
          Aplica a todas las empresas y usuarios de la cuenta.{!esAdmin && ' Solo un administrador puede cambiarlo.'}
        </p>
      </div>
      <SelectorDeTema tema={tema} guardando={guardando} onElegir={elegir} />
    </div>
  );
}
